import React, { useEffect } from "react";

import { StartActivity, sleep } from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

const WijzigStatus = () => {
  useEffect(async () => {
    $("#wijzig_status").on("show.bs.modal", async function (event) {
      var selectedIds = [];

      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      let result = await omnimap.GetActivityDefinitionAction(
        selectedIds[0],
        "3a98846b-67c1-4192-9edc-b980f10898b8",
        window.$mm_management_units_token
      );

      CallBackFunctions.WijzigStatusCallback(result, "wijzig-status-grp");
    });
  });

  const handleSubmit = () => {
    $("#cover-spin").show(0);
    var disciplineId = $("input[name=wijzig-status]:checked").attr("id");
    var element = $("input[name=wijzig-status]:checked");
    var label = element[0].defaultValue;
    var model = { status: label };
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    StartActivity(
      model,
      selectedIds,
      "3a98846b-67c1-4192-9edc-b980f10898b8",
      WijzigStatusSaved,
      window.$mm_management_units_token
    );
  };
  const WijzigStatusSaved = () => {
    sleep(900).then(() => {
      $("#wijzig_status").modal("hide");
      window.$mm_budget_refresh();
      /*omnimap
        .FillTableAction(
          window.$mm_budget_lastUsedTableFilter,
          1,
          window.$mm_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  };

  return (
    <div className="modal fade" tabIndex={-1} role="dialog" id="wijzig_status">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Wijzig status</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input type="search" className="modal-search" placeholder="" />
            <div className="modal-scroll">
              <div id="wijzig-status-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_wijzig_status"
              className="btn-modal"
              onClick={handleSubmit}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WijzigStatus;
